import { webOpenSDK } from '@weapp/utils';
import { setTimeoutOnce } from '../../../utils';
import { IDialogManager } from './types';

const dialogKey = 'dlg/';

export const getBaseStr = (linkPath: string) => {
  if (!linkPath) return '';

  const [, firstDlg, secondDlg] = linkPath.split(dialogKey);
  let baseStr = firstDlg;

  if (secondDlg) {
    [baseStr] = secondDlg.split('/');
  }
  return baseStr;
};

// link弹窗会打开iframe，需要集成父窗口的全局对象
const getGlobalVariable = (globalKey: string, context: any = window): any => {
  if (context[globalKey]) {
    return context[globalKey];
  }
  if (context.parent && context.parent !== context.top) {
    try {
      const topGlobalVariable = context.top[globalKey];

      return topGlobalVariable || getGlobalVariable(globalKey, context.top);
    } catch {
      return context[globalKey];
    }
  }

  /** 存在跨域行为取不到window.top 的情况 */
  try {
    return context.top[globalKey];
  } catch (error) {
    return context[globalKey];
  }
};

const GLOBALDIALOGMANAGER = 'ebdpageDialogManager';

export const dialogManager: IDialogManager = getGlobalVariable(GLOBALDIALOGMANAGER) || {
  index: -1,
  dialogs: [],
  getIndex(instance) {
    return this.dialogs.findIndex((dialog) => dialog === instance);
  },
  push(instance) {
    if (!this.dialogs.includes(instance)) {
      this.dialogs[++this.index] = instance;
    } else {
      const currentIndex = this.getIndex(instance);
      this.dialogs.splice(currentIndex, 1);
      this.dialogs.push(instance);
    }
    return this.index;
  },
  remove(instance) {
    const currentIndex = this.getIndex(instance);
    if (currentIndex > -1) {
      this.index--;
      return this.dialogs.splice(currentIndex, 1);
    }
    return [];
  },
};

// 确保全局变量唯一
window[GLOBALDIALOGMANAGER] = dialogManager;

// eslint-disable-next-line max-len
export const isLastDialog = (dialogInstance: any) => dialogManager.dialogs[dialogManager.index] === dialogInstance;
export const pushDialog = (dialogInstance: any) => dialogManager.push(dialogInstance);
export const removeDialog = (dialogInstance: any, isAsync?: boolean) => {
  if (isAsync) {
    setTimeoutOnce(() => dialogManager.remove(dialogInstance));
  } else {
    dialogManager.remove(dialogInstance);
  }
};

// 定义一个函数来模拟findIndex方法
export const findIndex = (array: Array<any>, predicate: Function) => {
  for (let i = 0; i < array.length; i++) {
    if (predicate(array[i])) {
      return i;
    }
  }
  return -1; // 如果未找到满足条件的元素，则返回-1
};
/**
 * 刷新EB组件
 */
export const refreshEbComs = () => {
  webOpenSDK.exec({ type: 'openerHook', args: [window] });
};
export default {};
